<template>
  <div id="notice-list">
    <hr id="divider-fat">
    <template v-if="noticeList.length">
      <comp-notice-item
        v-for="(notice, index) in noticeList"
        :key="notice.bbsId"
        :num="index + 1"
        :title="notice.title"
        :dateTime="notice.regDate"
        @noticeDetail="goPage(`/notice/${notice.bbsId}`)"
      />
    </template>
    <comp-loading
      v-if="isLoading"
    ></comp-loading>
  </div>
</template>

<script>
import common from '@/utils/common';
import RESPONSE from '@/constants/response';
import CompNoticeItem from '@/components/CompNoticeItem';
import CompLoading from '@/components/CompLoading';

export default {
  name: 'notice-list',
  mixins: [
    common,
  ],
  components: {
    RESPONSE,
    CompNoticeItem,
    CompLoading,
  },
  data() {
    return {
      noticeList: [],

      isLoading: false,
    };
  },
  methods: {
    getNoticeList() {
      this.isLoading = true;

      this.$store.dispatch('getNoticeList')
        .then((data) => {
          if (data.status === RESPONSE.TOKEN_EXPIRED.CODE) {
            this.$store.dispatch('refreshToken').then((response) => {
              if (response.status === RESPONSE.SUCCESS.CODE) {
                this.getNoticeList();
              } else {
                this.invalidateLogin();
              }
            });
          } else if (data.status === RESPONSE.SUCCESS.CODE) {
            const paramType = this.$route.params.type;
            let bbsType = '010301';
            if (paramType === 'faq') {
              bbsType = '010302';
            }
            const noticeData = data.data.filter(bbs => (bbs.bbsType === bbsType));
            if (noticeData) {
              this.noticeList = noticeData.reverse();
            }
          }
          this.isLoading = false;
        });
    },
  },
  created() {
    this.getNoticeList();
  },
};
</script>

<style lang="scss" src="../../scss/notice-list.scss" scoped></style>



// WEBPACK FOOTER //
// src/views/notice/notice-list.vue